import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from '@shopify/polaris';
import '@shopify/polaris/build/esm/styles.css';
import App from './App';
import { initAppBridge } from './utils/appBridge';

// Add global style to remove grey background and ensure vertical layout
const style = document.createElement('style');

// Check if we're in an iframe (customer view) or admin context
const isInIframe = window.self !== window.top;
const urlParams = new URLSearchParams(window.location.search);
const isAdmin = window.location.pathname.includes('/admin') || 
                urlParams.get('embedded') === '1' ||
                urlParams.get('host');

style.textContent = `
  body {
    background-color: white !important;
    ${isInIframe && !isAdmin ? 'overflow: hidden !important;' : 'overflow-y: auto !important;'}
  }
  html {
    ${isInIframe && !isAdmin ? 'overflow: hidden !important;' : 'overflow-y: auto !important;'}
  }
  .Polaris-Page {
    background-color: white !important;
    max-width: 100% !important;
  }
  .Polaris-Page__Content {
    background-color: white !important;
    max-width: 100% !important;
  }
  /* Force full width for page wrapper */
  .Polaris-Page-Content {
    max-width: 100% !important;
  }
  /* Force vertical layout for FAQ and Order Status */
  .Polaris-Card {
    width: 100% !important;
    max-width: 100% !important;
    display: block !important;
    float: none !important;
  }
  .Polaris-BlockStack {
    display: flex !important;
    flex-direction: column !important;
    width: 100% !important;
    max-width: 100% !important;
  }
  .Polaris-BlockStack > * {
    width: 100% !important;
    max-width: 100% !important;
  }
  /* Ensure iframe content doesn't create internal scrolling */
  #root {
    overflow: visible !important;
    max-width: 100% !important;
  }
`;
document.head.appendChild(style);

// Initialize App Bridge for embedded apps
initAppBridge();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProvider i18n={{}}>
      <App />
    </AppProvider>
  </React.StrictMode>
);

